<script setup lang="ts">
//#region import
import DashboardView from './DashboardView.vue';
//#endregion
</script>

<template>
  <DashboardView
    type-view="add"
  />
</template>
